import { localizePath } from '@core/i18n/localized-route.utils';

export interface PlaceholderRouteConfig {
  path: string;
  pageTitleKey: string;
  prerender?: boolean;
}

export const PLACEHOLDER_ROUTES: PlaceholderRouteConfig[] = [
  { path: 'regbr', pageTitleKey: 'nav.items.regbr', prerender: true },
  { path: 'regbr/metricas', pageTitleKey: 'nav.items.regbr', prerender: true },
  { path: 'igualdade-racial', pageTitleKey: 'nav.items.racialEquality', prerender: true },
  { path: 'nuvem-perguntas', pageTitleKey: 'nav.items.questionCloud', prerender: true },
  { path: 'perguntas/:slug', pageTitleKey: 'nav.items.questionCloud' },
  { path: 'evidencia-express', pageTitleKey: 'nav.items.evidenceExpress', prerender: true },
  { path: 'datastories', pageTitleKey: 'nav.items.dataStories', prerender: true },
  { path: 'datastories/:slug', pageTitleKey: 'nav.items.dataStories' },
  {
    path: 'ambiente-remoto-pesquisa',
    pageTitleKey: 'nav.remoteResearchEnvironment',
    prerender: true,
  },
  { path: 'quem-somos', pageTitleKey: 'nav.aboutUs', prerender: true },
  { path: 'servicos', pageTitleKey: 'nav.services', prerender: true },
  { path: 'relatorios', pageTitleKey: 'nav.items.reports', prerender: true },
  { path: 'eventos', pageTitleKey: 'nav.events', prerender: true },
];

const DEFAULT_PRERENDER_PATHS = [
  '',
  ...PLACEHOLDER_ROUTES.filter((route) => route.prerender).map((route) => route.path),
];

export const PRERENDER_PATHS = [
  ...DEFAULT_PRERENDER_PATHS,
  ...DEFAULT_PRERENDER_PATHS.map((path) => localizePath(`/${path}`, 'en').slice(1)),
];
